import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormControlLabel as MuiFormControlLabel, Checkbox } from '@material-ui/core';
import { lightGray, darkPurple } from 'utils/color-styles';
import { ChallengeFormData } from '../types';

interface CompetitionTypeStepProps {
  control: Control<ChallengeFormData>;
}

const CompetitionTypeStep = ({ control }): CompetitionTypeStepProps => {
  return (
    <div>
      <div style={{ marginBottom: 40 }}>
        <p style={{ marginBottom: 5 }}>Competition Type</p>
        <div style={{ marginTop: 20 }}>
          <Controller
            name="rules.actionsCompleted.isExclude"
            control={control}
            defaultValue={true}
            render={() => (
              <div
                style={{
                  backgroundColor: lightGray,
                  padding: '2px',
                  paddingRight: '12px',
                  borderRadius: '8px',
                  border: '1px solid #e0e0e0',
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
              >
                <MuiFormControlLabel
                  control={
                    <Checkbox
                      checked={true}
                      disabled={true}
                      style={{
                        color: darkPurple,
                      }}
                    />
                  }
                  label="Actions"
                  style={{ margin: 0 }}
                />
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default CompetitionTypeStep;
